import { Seo } from "../components/Seo";
import { Eyebrow } from "../components/motion";
import { LEGAL_PAGES, LEGAL_CONTACT_EMAIL } from "../data/content";

// Rend les adresses e-mail cliquables dans les textes légaux.
const Text = ({ children }) =>
  children.split(LEGAL_CONTACT_EMAIL).flatMap((part, i, arr) =>
    i < arr.length - 1
      ? [part, <a key={i} href={`mailto:${LEGAL_CONTACT_EMAIL}`} className="text-neon-light underline-offset-4 hover:underline" data-testid="legal-email-link">{LEGAL_CONTACT_EMAIL}</a>]
      : [part]
  );

export default function Legal({ slug }) {
  const page = LEGAL_PAGES[slug];
  if (!page) return null;

  return (
    <main className="px-6 pb-24 pt-40 sm:px-10 lg:px-16" data-testid={`page-${slug}`}>
      <Seo title={`${page.title} | Demoiselle Atypique`} description={`${page.title} du site Demoiselle Atypique — SAS DEMOISELLE ATYPIQUE, investissement immobilier atypique & accompagnement.`} />
      <div className="mx-auto max-w-3xl">
        <Eyebrow>Informations légales</Eyebrow>
        <h1 className="mt-6 font-serif text-4xl text-cream sm:text-5xl">{page.title}</h1>
        {page.intro && <p className="mt-8 leading-relaxed text-white/60">{page.intro}</p>}
        <div className="mt-12 space-y-10">
          {page.blocks.map((block) => (
            <section key={block.h} data-testid={`legal-block-${block.h.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-")}`}>
              <h2 className="font-serif text-2xl text-cream">{block.h}</h2>
              {block.p.map((paragraph, i) => (
                <p key={i} className="mt-3 leading-relaxed text-white/55">
                  <Text>{paragraph}</Text>
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
